import { isLegacyFeaturedEnabledByDefault } from './legacy-experiments';
import { safelyAccessLocalStorage, getParameterByName, getNamespacedFeatureKey } from './utils';
import { featureToggleMap } from './features';
export var ANSWERS_FED_PETRI_SCOPES = ['answers-all', 'answers-client'];
var isLegacyKey = function (key) {
    return typeof isLegacyFeaturedEnabledByDefault(key) === 'boolean';
};
// tslint:disable-next-line:max-line-length
export var isFeatureEnabled = function (key, win) {
    var w = win || (typeof window !== 'undefined' && window);
    var queryValue = w ? getParameterByName(key, w) : '';
    var rawWindowValue = w ? w[getNamespacedFeatureKey(key)] : '';
    var rawLocalStorageValue = safelyAccessLocalStorage(getNamespacedFeatureKey(key));
    if (isLegacyKey(key)) {
        if (queryValue) {
            return queryValue === 'true';
        }
        else if (rawWindowValue || rawWindowValue === false) {
            return rawWindowValue === true || rawWindowValue === 'true';
        }
        else if (rawLocalStorageValue) {
            return rawLocalStorageValue === 'true';
        }
        else {
            return isLegacyFeaturedEnabledByDefault(key);
        }
    }
    else {
        var experiments = w.__ansExperiments || {};
        var info = featureToggleMap[key];
        var specValue = info && experiments ? experiments[info.petriSpec] : undefined;
        if (queryValue) {
            return queryValue === 'true';
        }
        if (typeof rawWindowValue === 'boolean') {
            return rawWindowValue;
        }
        if (typeof rawLocalStorageValue === 'string') {
            return rawLocalStorageValue === 'true';
        }
        if (typeof specValue === 'string') {
            return specValue === 'true';
        }
        else {
            return info && info.default ? true : false;
        }
    }
};
export var isFeatureEnabledByDefault = function (key) {
    if (isLegacyKey(key)) {
        return isLegacyFeaturedEnabledByDefault(key);
    }
    else {
        return featureToggleMap[key].default;
    }
};
// Value will always be boolean according to specs
// tslint:disable-next-line:max-line-length
export var overrideFeatureToggle = function (key, value, win) {
    var w = win || window;
    w[getNamespacedFeatureKey(key)] = value;
};
export var restoreFeatureToggleDefault = function (key, win) {
    return overrideFeatureToggle(key, isFeatureEnabledByDefault(key), win);
};
//# sourceMappingURL=index.js.map